import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ManualTransaction } from './ManualTransaction';

@Injectable({
  providedIn: 'root'
})
export class ManualTransactionsService {

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    if ( error.error && this.isJson(error.error) ) {
      return Promise.reject(JSON.parse(error.error));
    }
    return Promise.reject(error.message || error);
  }

  private isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  get(iPlaceIds: string, start: number, end: number): Promise<any>{
    let url = this.basePath + "manual_transaction";
    let params = new HttpParams();
    params = params.append('iPlaceIds', iPlaceIds)
      .append('startDate', start.toString())
      .append('endDate', end.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as ManualTransaction[])
      .catch( error => this.errorHandler(error) );
  }

  create(manualTransaction: ManualTransaction[]){
    let url = this.basePath + "manual_transaction";
    return this.http.post(url, manualTransaction, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }
}
